import React from 'react'
import { Main } from './components'

const OrderPreparation = () => <Main />

export default OrderPreparation
